import {ActivatedRoute, Router} from "@angular/router";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class StateManagementService {
  private readonly KeyPrefix = 'state-';

  constructor(private router: Router, private route: ActivatedRoute) {
  }

  public setState<T>(key: string, filter: T) {
    key = this.KeyPrefix + key;

    // Set filter in query params
    let clonedFilter = {};

    Object.keys(filter).filter(key => filter[key] !== null && filter[key] !== undefined && filter[key] !== '').forEach(key => {
      clonedFilter[key] = filter[key];
    })

    sessionStorage.setItem(key, JSON.stringify(clonedFilter));

    const baseUrl = this.router.url.split('?')[0].substring(1);
    this.router.navigate([baseUrl], {queryParams: clonedFilter})
  }

  public getState<T>(key: string, defaultFilter: T): T {
    key = this.KeyPrefix + key;

    let filter = {} as T;

    // Url takes precedence over session storage
    // First build filter from query params
    const params = this.route.snapshot.queryParams;
    Object.keys(params).forEach(key => {
      filter[key] = params[key];
    });

    // If any properties were found in the query params, return the filter
    if (Object.keys(filter).length > 0) {
      // Update session storage
      sessionStorage.setItem(key, JSON.stringify(filter));
      return (filter);
    }

    // If no properties were found in the query params, check session storage

    try{
      const filter = JSON.parse(sessionStorage.getItem(key));
      if(filter){
        return filter;
      }
    }catch (e){}
    return defaultFilter;
  }

  public clearState(key: string) {
    key = this.KeyPrefix + key;
    sessionStorage.removeItem(key);
  }

  public clearAllStates() {
    Object.keys(sessionStorage).filter(x => x.startsWith(this.KeyPrefix)).forEach(key => {
      sessionStorage.removeItem(key);
    })
  }
}
